export const TOGGLE_LINK = '@link/ToggleLink'
